<div class="white-box container-fluid mb-5 v4-px-3">
    <div>
      <div class="grey-box">
        <h3 class="mx-2">{{'Impact Measurement' | translator}}</h3>
        <div class="dynamic-table-main-tr">
          <!-- Header -->
          <div class="row f-table">
            <div class="col-md-1 col-12">
              <div class="v4-bold">#</div>
            </div>
            <div class="col-md-2 col-12">
              <div class="v4-bold">{{ "Name" | translator }}</div>
            </div>
            <div class="col-md-2 col-12">
              <div class="v4-bold">{{ "Date" | translator }}</div>
            </div>
            <div class="col-md-1 col-12">
              <div class="v4-bold">{{ "time" | translator }}</div>
            </div>
            <div class="col-md-3 col-12">
              <div class="v4-bold">{{ "Link" | translator }}</div>
            </div>
            <div class="col-md-3 col-12">
              <div class="v4-bold">{{ "Action" | translator }}</div>
            </div>
  
            <!-- End Header -->
          </div>
        </div>
        <ng-container>
          <!-- Training  -->
          <ng-container *ngFor="let user of usersData; let i = index">
            <div class="row px-2 mob-my-4">
              <div class="col-md-1 col-12 p-0 3333">
                <div class="tabel-detail-box adjustment">
                  <div class="d-flex">
                    <div class="ms-tabel-num-box">
                      <i class="pi pi-user f-2rem"></i>
                    </div>
                  </div>
                  <div class="d-flex bold">{{ i + 1 }}</div>
                </div>
              </div>
  
              <div class="col-md-2 col-12 p-0">
                <div class="tabel-detail-box">
                  <div class="tab-scroll"> {{ user.user.name.first }} {{ user.user.name.middle }}
                    {{ user.user.name.last }}</div>
                </div>
              </div>
  
              <div class="col-md-2 col-12 p-0">
                <div class="tabel-detail-box p-0-5">
                  <div
                    dir="ltr"
                    class="w-100"
                    *ngIf="!isInvited(user); else showdate"
                  >
                    <p-calendar
                      class="v4-timer"
                      inputId="calendar-timeonly"
                      [inputStyle]="{ 'text-align': 'right' }"
                      [(ngModel)]="user.date"
                      placeholder="{{'Date' | translator}}"
                    >
                    </p-calendar>
                  </div>
                  <ng-template #showdate>
                    <div class="tab-scroll">{{ user.date | date }}</div>
                  </ng-template>
                </div>
              </div>
  
              <div class="col-md-1 col-12 p-0">
                <div class="tabel-detail-box p-0-5">
                  <div
                    dir="ltr"
                    class="w-100"
                    *ngIf="!isInvited(user); else showtime"
                  >
                    <p-calendar
                      class="v4-timer"
                      inputId="calendar-timeonly"
                      [inputStyle]="{ 'text-align': 'right' }"
                      placeholder="{{'time' | translator}}"
                      [timeOnly]="true"
                      [(ngModel)]="user.time"
                    />
                  </div>
                  <ng-template #showtime>
                    <div class="tab-scroll">
                      {{ user.time | date : "hh:mm a" }}
                    </div>
                  </ng-template>
                </div>
              </div>
  
              <div class="col-md-3 col-12 p-0">
                <div class="tabel-detail-box p-0-5">
                  <div
                    class="d-flex align-items-center w-100"
                    *ngIf="!isInvited(user); else showZoomLink"
                  >
                    <input
                      type="text"
                      class="radius-8 v4-timer"
                      style="width: 100%"
                      pInputText
                      placeholder="{{'Link' | translator}}"
                      [(ngModel)]="user.zoomLink"
                    />
                  </div>
                  <ng-template #showZoomLink>
                    <div class="tab-scroll d-flex align-items-center">
                      <a href="{{ user.zoomLink }}" target="_blank"
                        ><i class="pi pi-link mx-2"></i>{{ user.zoomLink }}</a
                      >
                    </div>
                  </ng-template>
                </div>
              </div>
  
              <div class="col-md-3 col-12 p-0">
                <div class="tabel-detail-box">
                  <div
                    class="tab-scroll d-flex flex-wrap align-items-center"
                    *ngIf="!isInvited(user) && user?.survey?.length <= 0; else edit"
                  >
                    <a
                      pTooltip="{{ 'Send Invitation' | translator }}"
                      tooltipPosition="top"
                      class="invite-btn"
                      (click)="sendInvite(usersData , user)"
                      >{{'Invite' | translator}}</a
                    >
                  </div>
                  <ng-template #edit>
                    <div class="tab-scroll d-flex flex-wrap align-items-center">
                        <span
                          pTooltip="{{ 'Rest Schedule' | translator }}"
                          *ngIf="user?.survey?.length <= 0"
                          tooltipPosition="top"
                          class="tabel-circle-btn"
                          (click)="
                            user.zoomLink = null;
                            user.date = null;
                            user.time = null;
                            removeIdFromArray(user.userId)
                          "
                          ><i class="pi pi-sync"></i
                        ></span>
                        
                      <div
                        pTooltip="{{ 'Start' | translator }}"
                        tooltipPosition="top"
                        class="main-btn mx-2"
                        (click)="navigateToUrl({userId : user.userId })"
                        *ngIf="!isExpired(user.date, user.time) && user?.survey?.length <= 0"
                      >
                        {{ "Attempt Survey" | translator }}
                      </div>

                      <p class="error" *ngIf="isExpired(user.date, user.time) && user?.survey?.length <= 0 ">{{ "Date Has Passed" | translator }}</p>

                      <i *ngIf="user?.survey?.length > 0" class="pi pi-check"></i>

                    </div>
                  </ng-template>
                </div>
              </div>
            </div>
  
            <ng-template #tick>
              <i class="pi pi-check"></i>
            </ng-template>
          </ng-container>
        </ng-container>
        <div class="flex justify-content-center my-3">
          <p-paginator [rowsPerPageOptions]="[10, 20, 30]"></p-paginator>
        </div>
      </div>
    </div>
  </div>